import { createAction, props } from '@ngrx/store';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';
import {
  AircraftProfileSkeleton,
  PagedAircraftProfileAudit,
  PagedAircraftPerformanceAudit,
  PagedAircraftProfileEngineAudit,
  PagedEngineAudit,
  PagedAircraftProfileComponentAudit,
  PagedComponentAudit,
  PagedColorSettingAudit,
  PagedPostFlightVisibilityAudit,
  PagedAircraftRelationAudit,
  PagedPhoneNumberAudit,
  PagedEmailAddressAudit,
  PagedAddressAudit,
  PagedAircraftBillingRateAudit
} from '../../+models/aircraft-profile-audit.model';

export const ResetAircraftProfile = createAction('[SharedAudit AircraftProfile] Reset');

// skeleton
export const LoadAircraftProfileAuditSkeleton = createAction(
  '[SharedAudit AircraftProfile] Load Aircraft Profile Audit Skeleton'
);

export const AircraftProfileAuditSkeletonLoaded = createAction(
  '[SharedAudit AircraftProfile] Aircraft Profile Audit Skeleton Loaded',
  props<AircraftProfileSkeleton>()
);

export const AircraftProfileAuditSkeletonLoadError = createAction(
  '[SharedAudit AircraftProfile] Aircraft Profile Audit Skeleton Load Error',
  props<{ err: any }>()
);

// AircraftProfile
export const LoadAircraftProfileAudit = createAction(
  '[SharedAudit AircraftProfile] Load Aircraft Profile Audit',
  props<{
    aircraftProfileId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageAircraftProfileAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Aircraft Profile Audit',
  props<{ aircraftProfileId: number }>()
);

export const AircraftProfileAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Aircraft Profile Audit Loaded',
  props<{ aircraftProfileId: number; audits: PagedAircraftProfileAudit }>()
);

export const AircraftProfileAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Aircraft Profile Audit Load Error',
  props<{ err: any }>()
);

// AircraftPerformance
export const LoadAircraftPerformanceAudit = createAction(
  '[SharedAudit AircraftProfile] Load Aircraft Performance Audit',
  props<{
    aircraftPerformanceId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageAircraftPerformanceAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Aircraft Performance Audit',
  props<{ aircraftPerformanceId: number }>()
);

export const AircraftPerformanceAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Aircraft Performance Audit Loaded',
  props<{ aircraftPerformanceId: number; audits: PagedAircraftPerformanceAudit }>()
);

export const AircraftPerformanceAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Aircraft Performance Audit Load Error',
  props<{ err: any }>()
);

// AircraftProfileEngine
export const LoadAircraftProfileEngineAudit = createAction(
  '[SharedAudit AircraftProfile] Load Aircraft Profile Engine Audit',
  props<{
    aircraftProfileEngineId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageAircraftProfileEngineAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Aircraft Profile Engine Audit',
  props<{ aircraftProfileEngineId: number }>()
);

export const AircraftProfileEngineAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Aircraft Profile Engine Audit Loaded',
  props<{ aircraftProfileEngineId: number; audits: PagedAircraftProfileEngineAudit }>()
);

export const AircraftProfileEngineAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Aircraft Profile Engine Audit Load Error',
  props<{ err: any }>()
);

// Engine
export const LoadEngineAudit = createAction(
  '[SharedAudit AircraftProfile] Load Engine Audit',
  props<{ engineId: number; pageNumber: number | null; lastAuditLogId: number | null }>()
);

export const LoadNextPageEngineAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Engine Audit',
  props<{ engineId: number }>()
);

export const EngineAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Engine Audit Loaded',
  props<{ engineId: number; audits: PagedEngineAudit }>()
);

export const EngineAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Engine Audit Load Error',
  props<{ err: any }>()
);

// AircraftProfileComponent
export const LoadAircraftProfileComponentAudit = createAction(
  '[SharedAudit AircraftProfile] Load Aircraft Profile Component Audit',
  props<{
    aircraftProfileComponentId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageAircraftProfileComponentAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Aircraft Profile Component Audit',
  props<{ aircraftProfileComponentId: number }>()
);

export const AircraftProfileComponentAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Aircraft Profile Component Audit Loaded',
  props<{
    aircraftProfileComponentId: number;
    audits: PagedAircraftProfileComponentAudit;
  }>()
);

export const AircraftProfileComponentAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Aircraft Profile Component Audit Load Error',
  props<{ err: any }>()
);

// Component
export const LoadComponentAudit = createAction(
  '[SharedAudit AircraftProfile] Load Component Audit',
  props<{
    componentId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageComponentAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Component Audit',
  props<{ componentId: number }>()
);

export const ComponentAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Component Audit Loaded',
  props<{ componentId: number; audits: PagedComponentAudit }>()
);

export const ComponentAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Component Audit Load Error',
  props<{ err: any }>()
);

// ColorSetting
export const LoadColorSettingAudit = createAction(
  '[SharedAudit AircraftProfile] Load Color Setting Audit',
  props<{
    colorSettingId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageColorSettingAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Color Setting Audit',
  props<{ colorSettingId: number }>()
);

export const ColorSettingAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Color Setting Audit Loaded',
  props<{ colorSettingId: number; audits: PagedColorSettingAudit }>()
);

export const ColorSettingAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Color Setting Audit Load Error',
  props<{ err: any }>()
);

// PostFlightVisibility
export const LoadPostFlightVisibilityAudit = createAction(
  '[SharedAudit AircraftProfile] Load Postflight Visibility Audit',
  props<{
    postFlightVisibilityId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPagePostFlightVisibilityAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Postflight Visibility Audit',
  props<{ postFlightVisibilityId: number }>()
);

export const PostFlightVisibilityAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Postflight Visibility Audit Loaded',
  props<{ postFlightVisibilityId: number; audits: PagedPostFlightVisibilityAudit }>()
);

export const PostFlightVisibilityAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Postflight Visibility Audit Load Error',
  props<{ err: any }>()
);

// AircraftBillingRate
export const LoadAircraftBillingRateAudit = createAction(
  '[SharedAudit AircraftProfile] Load Aircraft Billing Rate Audit',
  props<{
    aircraftBillingRateId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageAircraftBillingRateAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Aircraft Billing Rate Audit',
  props<{ aircraftBillingRateId: number }>()
);

export const AircraftBillingRateAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Aircraft Billing Rate Audit Loaded',
  props<{ aircraftBillingRateId: number; audits: PagedAircraftBillingRateAudit }>()
);

export const AircraftBillingRateAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Aircraft Billing Rate Audit Load Error',
  props<{ err: any }>()
);

// AircraftRelation
export const LoadAircraftRelationAudit = createAction(
  '[SharedAudit AircraftProfile] Load Aircraft Relation Audit',
  props<{
    aircraftRelationId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageAircraftRelationAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Aircraft Relation Audit',
  props<{ aircraftRelationId: number }>()
);

export const AircraftRelationAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Aircraft Relation Audit Loaded',
  props<{ aircraftRelationId: number; audits: PagedAircraftRelationAudit }>()
);

export const AircraftRelationAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Aircraft Relation Audit Load Error',
  props<{ err: any }>()
);

// PhoneNumber
export const LoadPhoneNumberAudit = createAction(
  '[SharedAudit AircraftProfile] Load PhoneNumber Audit',
  props<{
    phoneNumberId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPagePhoneNumberAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage PhoneNumber Audit',
  props<{ phoneNumberId: number }>()
);

export const PhoneNumberAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] PhoneNumber Audit Loaded',
  props<{ phoneNumberId: number; audits: PagedPhoneNumberAudit }>()
);

export const PhoneNumberAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] PhoneNumber Audit Load Error',
  props<{ err: any }>()
);

// FaxNumber
export const LoadFaxNumberAudit = createAction(
  '[SharedAudit AircraftProfile] Load FaxNumber Audit',
  props<{
    phoneNumberId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageFaxNumberAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage FaxNumber Audit',
  props<{ phoneNumberId: number }>()
);

export const FaxNumberAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] FaxNumber Audit Loaded',
  props<{ phoneNumberId: number; audits: PagedPhoneNumberAudit }>()
);

export const FaxNumberAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] FaxNumber Audit Load Error',
  props<{ err: any }>()
);

// EmailAddress
export const LoadEmailAddressAudit = createAction(
  '[SharedAudit AircraftProfile] Load EmailAddress Audit',
  props<{
    emailAddressId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageEmailAddressAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPageEmailAddress Audit',
  props<{ emailAddressId: number }>()
);

export const EmailAddressAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Email Address Audit Loaded',
  props<{ emailAddressId: number; audits: PagedEmailAddressAudit }>()
);

export const EmailAddressAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Email Address Audit Load Error',
  props<{ err: any }>()
);

// Address
export const LoadAddressAudit = createAction(
  '[SharedAudit AircraftProfile] Load Address Audit',
  props<{ addressId: number; pageNumber: number | null; lastAuditLogId: number | null }>()
);

export const LoadNextPageAddressAudit = createAction(
  '[SharedAudit AircraftProfile] Load NextPage Address Audit',
  props<{ addressId: number }>()
);

export const AddressAuditLoaded = createAction(
  '[SharedAudit AircraftProfile] Address Audit Loaded',
  props<{ addressId: number; audits: PagedAddressAudit }>()
);

export const AddressAuditLoadError = createAction(
  '[SharedAudit AircraftProfile] Address Audit Load Error',
  props<{ err: any }>()
);

// References
export const LoadAircraftRelationTypes = createAction(
  '[SharedAudit AircraftProfile] Load Aircraft Relation Type'
);

export const AircraftRelationTypesLoaded = createAction(
  '[SharedAudit AircraftProfile] Aircraft Relation Type Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const AircraftRelationTypesLoadError = createAction(
  '[SharedAudit AircraftProfile] Aircraft Relation Type Load Error',
  props<{ err: any }>()
);

export const LoadAircraftRelationSubTypes = createAction(
  '[SharedAudit AircraftProfile] Load Aircraft Relation Sub Type'
);

export const AircraftRelationSubTypeLoaded = createAction(
  '[SharedAudit AircraftProfile] Aircraft Relation Sub Type Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const AircraftRelationSubTypesLoadError = createAction(
  '[SharedAudit AircraftProfile] Aircraft Relation Sub Type Load Error',
  props<{ err: any }>()
);

export const LoadPostFlightVisibilityTypes = createAction(
  '[SharedAudit AircraftProfile] Load PostFlight Visibility Type'
);

export const PostFlightVisibilityTypesLoaded = createAction(
  '[SharedAudit AircraftProfile] PostFlight Visibility Type Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const PostFlightVisibilityTypesLoadError = createAction(
  '[SharedAudit AircraftProfile] PostFlight Visibility Type Load Error',
  props<{ err: any }>()
);
